import { getCopyText } from "lib/getCopyText"
import useCurrent from "lib/use-current"

export const getExhibitorsCopyText = (
  current: Exclude<ReturnType<typeof useCurrent>, undefined>,
) => {
  return getCopyText(current.config.exhibitor_copy_text)
}
